// The brief (14 October 2026): the "weekly" entry becomes "the brief", read by
// the week, the fortnight, the month, the half-year and the year, each scale
// with its past editions. The idea cards keep their texts (`epureWeekly`,
// `projector.weekly`).
export default {
  echelles: 'Brief scale',
  terrain: 'What the field says',
  periodes: {
    hebdo: 'Week',
    bimensuel: 'Fortnight',
    mensuel: 'Month',
    semestriel: 'Half-year',
    annuel: 'Year',
  },
  edition: {
    hebdo: 'Week of {du} to {au}',
    bimensuel: 'Fortnight of {du} to {au}',
    mensuel: '{mois}',
    semestre1: 'First half {an}',
    semestre2: 'Second half {an}',
    annuel: '{an}',
    partielle: '{periode}, to {au}',
  },
  editionAria: 'Choose an edition',
  lire: {
    hebdo: 'Read the week',
    bimensuel: 'Read the fortnight',
    mensuel: 'Read the month so far',
    semestriel: 'Read the half-year so far',
    annuel: 'Read the year so far',
  },
  seLit: {
    hebdo: 'Reading the week.',
    bimensuel: 'Reading the fortnight.',
    mensuel: 'Reading the month.',
    semestriel: 'Reading the half-year.',
    annuel: 'Reading the year.',
  },
  pasEncore: {
    hebdo: 'No brief of the week yet.',
    bimensuel: 'No brief of the fortnight yet.',
    mensuel: 'No brief of the month yet.',
    semestriel: 'No brief of the half-year yet.',
    annuel: 'No brief of the year yet.',
  },
  prochaine: {
    hebdo: 'The brief of the week comes out by itself every week. "Read the week" runs it now.',
    bimensuel: 'The brief of the fortnight comes out by itself every two weeks. "Read the fortnight" runs it now.',
    mensuel: 'The brief of the month comes out by itself on {jour}, on the month just ended. "Read the month so far" reads it now.',
    semestriel: 'The brief of the half-year comes out by itself on {jour}, on the half-year just ended. "Read the half-year so far" reads it now.',
    annuel: 'The brief of the year comes out by itself on {jour}, on the year just ended. "Read the year so far" reads it now.',
  },
  terrainDepuis: 'The field covers this period from {jour}.',
}
